export type MobileOS = 'ios' | 'android' | 'other';

export const getMobileOS = (): MobileOS => {
  if (typeof navigator === 'undefined') {
    return 'other';
  }

  const userAgent = navigator.userAgent || (window as any).opera || '';

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  // iOS devices, including iPadOS which reports as "Macintosh" but supports touch.
  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1);

  if (isIOS) {
    return 'ios';
  }

  return 'other';
};
